module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title1"
  }, [_vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I could not have made this book without the help of the Iowa Wine Growers Association, Iowa State University, the Amana Heritage Association, Backcountry Winery, Summerset Winery, Ackerman Winery and Tassel Ridge Winery.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some special acknowledgements are due to Michael White, Tom Gardner, Linda Ackerman, Cassie Bott, Peter Hoehnle, Rebecca Dickman, Katie Reinhardt, Tonya Bolt, Amber Gable, Bob Wersen, Deb Hamilton, Clayton Walker, Michael DeCapria, Chad Rhoad, Hilary Parrish and Gena Schantz.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1789404b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgements.vue
// module id = 72
// module chunks = 0